import {
  Star, MapPin, AtSign, Search, Link, Package, Layout, Code2, Plug, Boxes, Wrench,
  Share2, FileText, Palette, Megaphone, FileCode2, Atom, Code, Globe,
  type LucideIcon,
} from "lucide-react";

const MAP: Record<string, LucideIcon> = {
  Star, MapPin, AtSign, Search, Link, Package, Layout, Code2, Plug, Boxes, Wrench,
  Share2, FileText, Palette, Megaphone, FileCode2, Atom, Code, Globe,
  Wordpress: Globe,
};

export function CategoryIcon({ name, className }: { name?: string | null; className?: string }) {
  const Icon = (name && MAP[name]) || Package;
  return <Icon className={className} />;
}
